export default __webpack_public_path__ + "static/media/Path3457.98c50cf6.svg";